/* unplugin-vue-components disabled */import script from "./red_note_prize.vue?vue&type=script&setup=true&lang=js"
export * from "./red_note_prize.vue?vue&type=script&setup=true&lang=js"

import "./red_note_prize.vue?vue&type=style&index=0&id=104838b4&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104838b4"]])

export default __exports__